import { clearAuthSessionStorage, setAuthToken } from '@auth/session-storage';

export const SupportLogin: React.FunctionComponent = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    clearAuthSessionStorage();
    if (token) {
        setAuthToken(token);
    }
    window.location.href = '/';
    return <></>;
};
